<ng-container
  *ngIf="{ loading: loading$ | async, rtlDir: rtlDir$ | async } as vm"
>
  <app-main *ngIf="!vm.loading" [dir]="vm.rtlDir ? 'rtl' : 'ltr'"></app-main>
  <app-splash-screen [show]="vm.loading"></app-splash-screen>
</ng-container>

<ng-container #tourRef></ng-container>
